<template>
  <div class="video-entry">
    <div class="top" @click="goDetail" @touchstart="showFragment = true" @touchend="showFragment = false">
      <img class="cover" v-lazy="videoData.pic" />
      <img v-if="showFragment && videoData.gif" class="cover" v-lazy="videoData.gif" />
      <i v-if="videoData.is_vip" class="vip" />
      <div class="time">{{ videoData.date }}</div>
    </div>

    <div class="title">{{ videoData.title }}</div>

    <div class="bottom">
      <div class="left">
        <i class="label"/>
<!--        <span>{{ videoData.score }}</span>·-->
        <span v-if="videoData.label_name && videoData.label_name.length > 0">{{ videoData.label_name[0].name }}</span>·<span v-if="videoData.label_name && videoData.label_name.length > 1">{{ videoData.label_name[1].name }}</span>
      </div>
      <i class="collect" :class="{ active: videoData.is_collect === 1 }" @click="doCollect" />
    </div>
  </div>
</template>

<script>
// import { addCollect } from '@api/longVideo';

export default {
  name: 'VideoEntry',
  props: {
    videoData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showFragment: false
    };
  },
  methods: {
    ...mapActions('home', ['collect']),
    doCollect () {
      // // status 1点赞 ， 2取消点赞
      // const status = this.videoData.is_collect ? 2 : 1;
      // addCollect({ vid: this.videoData.id, status }).then(res => {
      //   if (res.result === 200000) {
      //     if (status === 1) {
      //       this.videoData.is_collect = 1;
      //     } else if (status === 2) {
      //       this.videoData.is_collect = 0;
      //     }
      //   }
      // });
      this.collect(this.videoData);
      this.$forceUpdate();
    },
    goDetail () {
      this.$emit('doSetScrollPositionY');
      localStorage.setItem('fromRoute', this.$route.fullPath);
      this.$router.push({ path: '/videoDetail', query: { videoId: this.videoData.id } });
    }
  }
};
</script>

<style lang="scss" scoped>
.video-entry {
  width: 172px;

  .top {
    position: relative;
    width: 172px;
    height: 105px;
    border-radius: 6px;
    overflow: hidden;
    .cover {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      //height: 105px;
    }

    .vip {
      position: absolute;
      right: 0;
      top: 0;
      width: 33px;
      height: 17px;
      background: url("~@assets/imgs/public/vipIcon.png") 0 0/100% 100%;
    }

    .time {
      position: absolute;
      bottom: 2px;
      right: 6px;
      //min-width: 41px;
      height: 19px;
      padding: 0 6px;
      background: url("~@assets/imgs/public/timeBg.png") 0 0/100% 100%;
      font-family: 'PingFang HK';
      font-size: 12px;
      line-height: 19px;
      color: #FFF;
    }
  }

  .title {
    width: 100%;
    margin: 8px 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: 'PingFang HK';
    font-weight: 400;
    font-size: 12px;
    line-height: 1;
    letter-spacing: -0.3px;
    color: #FFFFFF;
  }

  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1;

    .left {
      display: flex;
      align-items: center;

      .label {
        width: 8px;
        height: 8px;
        margin-right: 2px;
        background: url("./assets/label.png") 0 0/100% 100%;
      }

      span {
        font-family: 'PingFang HK';
        font-weight: 400;
        font-size: 9px;
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .collect {
      width: 16px;
      height: 16px;
      margin-right: 2px;
      background-image: url("~@assets/imgs/public/collect.png");
      background-size: 100% 100%;

      &.active {
        background-image: url("~@assets/imgs/public/collectActive.png");
      }
    }
  }
}
</style>
